import React from 'react'
import {useStyles} from "./TagContainer.css";

const TagContainer = ({tags, maxTags = 1000}) => {
    const classes = useStyles()

    return <div className={classes.tagContainer}>
        {tags?.map((tagEntry, index) => {
            if (index === maxTags - 1) {
                return <div key={tagEntry} className={classes.tagContainer}>
                    <div className={classes.tag}>{tagEntry}</div>
                    <b>...</b>
                </div>
            }
            if (index < maxTags) {
                return <div key={tagEntry} className={classes.tag}>{tagEntry}</div>
            }
        })}
    </div>
}

export default TagContainer
